<template>
    <modal id="poll-question-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('pollQuestion')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.POLL_QUESTION'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('poll')"
                        list-value-field="title"
                        :chooseLabel="$t('poll')"
                        v-model="formData.poll_id"
                        :required="true"
                        :error-message="$errorMessage(errors, 'poll_id')"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_POLL}`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('pollQuestions.question_text')"
                        type="text"
                        v-model="formData.question_text"
                        :placeholder="$placeholder('pollQuestions.question_text')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'question_text')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('pollQuestions.question_type')"
                        type="radio"
                        name="question_type"
                        :list="[
                            {id:'mcq',value: $t('mcq')},
                            {id:'rating', value:  $t('rating')},
                            {id:'open-ended', value:  $t('open-ended')}
                        ]"
                        v-model="formData.question_type"
                        :error-message="$errorMessage(errors, 'question_type')"
                        @change="handleQuestionTypeChange"
                    />
                </div>
            </div>

            <!-- Dynamic Fields -->
            <div class="col-md-12 mt-3">
                <!-- For MCQ -->
                <div v-if="formData.question_type === 'mcq'">
                    <div v-for="(option, index) in mcqOptions" :key="index" class="d-flex mb-2">
                        <input
                            type="text"
                            class="form-control"
                            v-model="option.text"
                            :placeholder="'Option ' + (index + 1)"
                            :class="{ 'is-invalid': errors[`mcq_options.${index}`] }"
                        />
                        <button type="button" class="btn btn-danger ml-2" @click="removeMcqOption(index)" v-if="mcqOptions.length > 1">-</button>
                    </div>
                    <div v-if="errors[`mcq_options.${index}`]" class="invalid-feedback d-block">
                        {{ errors[`mcq_options.${index}`][0] }}
                    </div>
                    <button type="button" class="btn btn-primary" @click="addMcqOption">+ Add Option</button>
                </div>

                <!-- For Rating -->
                <div v-if="formData.question_type === 'rating'">
                    <div class="smiley-rating">
                        <div
                            v-for="(smiley, index) in smileyOptions"
                            :key="index"
                            @click="ratingValue = index + 1"
                            :class="{ selected: ratingValue === index + 1 }"
                            class="smiley-option"
                        >
                            <span class="emoji">{{ smiley.emoji }}</span>
                            <span class="label">{{ smiley.label }}</span>
                        </div>
                    </div>
                </div>

                <!-- For Open Ended -->
                <div v-if="formData.question_type === 'open-ended'">
                    <textarea
                        class="form-control"
                        v-model="openEndedPlaceholder"
                        placeholder="User will enter answer during poll"
                        disabled
                    ></textarea>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost, axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {SELECTABLE_POLL_STATUS, POLL_QUESTION} from "../../../../Config/ApiUrl";


export default {
    name: "PollQuestionCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                question_type: '',
                poll_id: null,
            },
            mcqOptions: [{ text: '' }],
            openEndedPlaceholder: '',
            SELECTABLE_POLL_STATUS,
            pollOptions: [],
            ratingValue: 0,
            smileyOptions: [
                { emoji: '😍', label: 'Excellent' },
                { emoji: '😊', label: 'Good' },
                { emoji: '😐', label: 'Average' },
                { emoji: '😕', label: 'Poor' },
                { emoji: '😡', label: 'Very Poor' },
            ]
        };
    },
    computed: {
    },
    watch: {
        'formData.poll_id': {
            handler(newVal) {
                if (newVal) {
                    this.fetchPollOptions();
                }
            },
            immediate: true
        }
    },
    methods: {
        handleQuestionTypeChange() {
            // Optionally reset options when question_type changes
            if (this.formData.question_type === 'mcq') {
                this.mcqOptions = [{ text: '' }];
            } else if (this.formData.question_type === 'rating') {
                this.ratingValue = null;
            } else if (this.formData.question_type === 'open-ended') {
                this.openEndedPlaceholder = '';
            }
        },
        addMcqOption() {
            this.mcqOptions.push({ text: '' });
        },
        removeMcqOption(index) {
            this.mcqOptions.splice(index, 1);
        },
        fetchPollOptions() {
            if (this.selectedUrl) {
                axiosGet(this.selectedUrl).then(({data}) => {
                    if (data.poll_options && data.question_type === 'mcq') {
                        this.mcqOptions = data.poll_options.map(option => ({
                            text: option.option_text
                        }));
                    }
                });
            } else if (this.formData.poll_id) {
                // Fetch options for selected poll
                axiosGet(`${POLL_QUESTION}?poll_id=${this.formData.poll_id}`).then(({data}) => {
                    if (data.poll_options && data.question_type === 'mcq') {
                        this.mcqOptions = data.poll_options.map(option => ({
                            text: option.option_text
                        }));
                    }
                });
            }
        },
        mounted() {
            this.fetchPollOptions();
        },
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            let fd = new FormData();

            formData = formDataAssigner(fd, formData);

            if (this.formData.question_type === 'mcq') {
                this.mcqOptions.forEach((option, index) => {
                    fd.append(`mcq_options[${index}]`, option.text);
                });
            }

            // Add rating value if selected
            if (this.formData.question_type === 'rating') {
                fd.append('rating_value', this.ratingValue);
            }

            // Add open-ended placeholder (optional)
            if (this.formData.question_type === 'open-ended') {
                fd.append('open_ended_placeholder', this.openEndedPlaceholder);
            }

            let url = this.apiUrl.POLL_QUESTION;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, fd).then(({data}) => {
                this.loading = false;
                $('#poll-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'poll-question-table');
                // window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#poll-modal').modal('hide');
            this.toastAndReload(data.message, 'poll-question-table')
            this.$emit('input', false);
            window.location.reload();
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
